import Vue from 'vue'
import 'vuetify/dist/vuetify.min.css'
import
Vuetify from 'vuetify';
Vue.use(Vuetify, {
});